import { Fetch } from 'lib';
import type { CategoryQueryResult, Province } from 'types';

type RequestResponses = {
  provinces: Province[];
};

const getCities = async () =>
  await Fetch<RequestResponses>({
    url: 'city/getCities',
  });

export { getCities };
